//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Microalbuminuria',
  data() {
    return {
      form:{
        alb:'',
        cr:'',
      },
      hasScore:false,
      disabled:false,
      dummy: 'mmol/L'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    setUnitsValueName(data){
      let self = this
      self.dummy = data.key
      console.log(self.dummy)
    },
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // 比值（mg/mmol)=尿Alb（mg/L）/尿Cr（mmol/L）
        // 比值（mg/g)=尿Alb（mg/dL）/尿Cr（g/dL）

        let result = form.alb / form.cr
        console.log(88, result)
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Microalbuminuria.vue